import React from 'react';
import { compose, branch, withHandlers } from 'recompose';
import { duplicateTaopixProject, reorderProject } from '../../Common/Providers/ProjectApi';
import { addEphotobookToCart } from '../../Common/Providers/EPhotobookApi';
import { addReorderConfigurableProductToCart } from '../../Common/Providers/ConfigurableProductApi';
import { withSpinnerOnAjax } from '../../Common/Spinner';
import { isTaopixProject } from '../../Common/Helpers/CheckTaopixProject';
import { HTMLTrans, withTranslationProvider } from '../../Common/Translations';
import { withSupportEmail } from '../../Common/Helpers/SupportEmail';
import { withDataLayerAddToCart } from '../../Common/GTM/ECommerceTracking/withDataLayerAddToCart';
import { showErrorMsg } from '../../Common/ErrorMsg';

export const withPrintboxReorder = compose(
  withSpinnerOnAjax('reorderProject', reorderProject),
  withHandlers({
    onClick: ({ projectId, reorderedPbxDetail, reorderProject }) => () => {
      reorderProject(reorderedPbxDetail ? reorderedPbxDetail.original_project_id : projectId).done((response) => {
        window.location.href = response.data.redirect_to_cart_url;
      });
    }
  }),
);

export const withTaopixOfflineReorderOnClick = compose(
  withHandlers({
    onClick: ({ openModal }) => () => {
      openModal();
    },
  }),
);

export const withTaopixOnlineReorderOnClick = compose(
  withSpinnerOnAjax('duplicateTaopixProject', duplicateTaopixProject),
  withHandlers({
    onClick: ({ projectId : taopixProjectId, t, supportEmail, duplicateTaopixProject  }) => () => {
      duplicateTaopixProject({id: taopixProjectId, t, supportEmail })
        .done((response) => {
          window.location = response.data.redirect_to_cart_url;
        });
    },
  }),
);

export const withTaopixReorderable = WrappedComponent => (props) => {
  const { taopixReorderable = 'off' } = props;

  return (taopixReorderable !== 'on') ? null : <WrappedComponent {...props}/>;
};

export const withTaopixReorder = compose(
  withTaopixOnlineReorderOnClick,
  withTaopixReorderable
);

export const withEPhotobookReorder = compose(
  withSpinnerOnAjax('addEphotobookToCart', addEphotobookToCart),
  withDataLayerAddToCart,
  withHandlers({
    onClick: ({ 
      addEphotobookToCart,
      ephotobook: { productCode = '', productName = '', link: { file = '' } = {} } = {},
      dataLayerAddToCart,
      price,
      currency
    }) => () => {
      addEphotobookToCart({ file })
        .done((response) => {
          const data = {
            currencyCode: currency,
            product: {
              id: productCode,
              name: productName,
              category: 'Photobook',
              price,
              variant: productCode,
              quantity: 1
            },
            sourceOfAddingToCart: 'EPhotobook - order list page'
          };
          dataLayerAddToCart(data);
          window.location = response.data.redirect_to_cart_url;
        });
    }
  })
);

export const isEPhotobookProject = ({ ephotobook }) => (!!ephotobook);

export const withConfigurableProjectReorder = compose(
  withSpinnerOnAjax('addReorderConfigurableProductToCart', addReorderConfigurableProductToCart),
  withDataLayerAddToCart,
  withHandlers({
    onClick: ({ 
      addReorderConfigurableProductToCart,
      projectId,
      productProperties: { productCode = '' , productDisplayName = '', productSku = '' } = {},
      price,
      currency,
      dataLayerAddToCart
    }) => () => {
      addReorderConfigurableProductToCart(projectId, productCode, productSku)
        .done((response) => {
          const data = {
            currencyCode: currency, 
             product: {
              id: productCode,
              name: productDisplayName,
              category: 'PCP',
              price: price,
              variant: productCode,
              quantity: 1
            },
            sourceOfAddingToCart:  'Configurable Product - order list page'
          };
          dataLayerAddToCart(data);
          window.location = response.data.redirect_to_cart_url;
        })
        .fail(({ responseJSON: { errors = '' } }) => {
          showErrorMsg(errors);
        });
    }
  })
);

export const isConfigurableProject = ({ configurableProduct }) => (configurableProduct);

export const withReorder = compose(
  withTranslationProvider,
  withSupportEmail,
  branch(
    isTaopixProject,
    withTaopixReorder,
    branch(
      isEPhotobookProject,
      withEPhotobookReorder,
      branch(
        isConfigurableProject,
        withConfigurableProjectReorder,
        withPrintboxReorder
      ),
    ),
  )
);

const ReorderButton = props => <button
  type="button"
  onClick={props.onClick}
  style={{ width: '140px' }}
  className='btn btn-outline-primary btn-sm'>
    <HTMLTrans id="account.order_reorder_button">Reorder</HTMLTrans>
</button>;

export default withReorder(ReorderButton);



// WEBPACK FOOTER //
// ./src/Account/Order/Reorder.js